export const ADDRESS_TYPES = {
    PROXY: 'PROXY',
    SEASONAL: 'SEASONAL',
    DIVIDEND: 'DIVIDEND',
    EMAIL: 'EMAIL',
    REGISTERED: 'REGISTERED'
};

